// BFA staff app: every sentence the app says, in one place (tidy up step 2, 27.9.2026).
// A screen never writes a sentence itself: it asks t("key"), or t("key",{n:3}) where {n} is a blank and
// {phone|phones} picks by n. The words are exactly the ones the screens showed before; a second language
// is a second file with the same keys. Loaded before app.js (src/pages/app.js), so every script can ask.
// The rule for wording (Falak): plain words, "administration" (never "office"), no dashes.
var WORDS={
  "push.title":"Notifications",
  "push.why":"A tap on this phone when a plan is submitted to you, approved, or sent back with a note.",
  "push.iphone":"On an iPhone, notifications work once the app is on your Home Screen: tap Share, then <b>Add to Home Screen</b>, and open BFA from there.",
  "push.oldApp":"Update the BFA app in the Play Store, then open it again to turn notifications on.",
  "push.noBrowser":"This browser cannot show notifications. Open the app in Chrome or Safari to turn them on.",
  "push.blockedBrowser":"Notifications are blocked for BFA in this browser. Allow them in the browser settings, then come back here.",
  "push.checking":"Checking…",
  "push.notYet":"Not switched on for the academy yet.",
  "push.checkFail":"Could not check notifications on this phone.",
  "push.offComputer":"Off on this computer",
  "push.goToPhone":"Notifications go to your phone: open BFA there, then My account, and turn them on.",
  "push.on":"On for this phone",
  "push.off":"Off on this phone",
  "push.turnOn":"Turn on",
  "push.turnOff":"Turn off",
  "push.test":"Send me a test",
  "push.notAllowed":"Notifications were not allowed on this phone.",
  "push.oneMoment":"One moment…",
  "push.nowOn":"Notifications are on for this phone.",
  "push.nowOff":"Notifications are off on this phone.",
  "push.changeFail":"Could not change notifications.",
  "push.sent":"Sent. It should arrive in a moment.",
  "push.notSent":"Nothing was sent. Turn notifications on first.",
  "push.homeWhy":"A tap on this phone for your daily session reminder, and when a plan is approved, sent back, or waiting for you.",
  "push.notNow":"Not now",
  "push.getTitle":"Get BFA notifications",
  "push.turnOnTitle":"Turn on notifications",
  "push.iphoneHome":"On an iPhone they need the app on your Home Screen: tap <b>Share</b> at the bottom of Safari, then <b>Add to Home Screen</b>, then open BFA from its new icon.",
  "rank.owner":"Owner",
  "rank.admin":"Administration",
  "rank.headcoach":"Head coach",
  "rank.coach":"Coach",
  "rank.mover":"Coach who can move players",
  "push.onPhones":"on {n} {phone|phones}",
  "push.others":"on {n} other {phone|phones}",
  "me.mySessions":"My sessions",
  "me.msOlder":"‹ Earlier",
  "me.msNewer":"Later ›",
  "me.msHeld":"{n} {session|sessions} held",
  "me.msPresent":"Marked present",
  "me.msNotMarked":"Not marked yet",
  "me.msAbsent":"Marked absent",
  "me.msHint":"A session not marked yet: open it and mark yourself, or ask your head coach or administration.",
  "me.msNone":"No session held in this month.",
  "me.msNotLinked":"Your login is not linked to a coach record yet. Ask administration to link it under Administration › Staff accounts.",
  "me.msCouldNotLoad":"Your sessions could not be loaded just now.",
  "me.msCoach":"Coach",
  "me.msAssistant":"Assistant",
  "me.msMatch":"match",
  "me.msMarkPresent":"Present",
  "me.msMarkAbsent":"Absent",
  "me.msMarkNone":"Not marked",
  "me.title":"My account",
  "me.name":"Name",
  "me.branchSignIn":"Branch sign-in",
  "me.notSet":"Not set",
  "me.email":"Sign-in email",
  "me.role":"Role",
  "me.branches":"Branches",
  "me.setByAdmin":"Your name, role and branches are set by administration. Ask them if something here is wrong.",
  "me.password":"Password",
  "me.viewingAs":"You are viewing the app as {name}. Exit view-as to manage your own password and notifications.",
  "me.pinNoPassword":"You are signed in with a shared branch PIN, so there is no personal password to change. Ask an administrator for your own login if you want one.",
  "me.changePassword":"Change my password",
  "me.current":"Current password",
  "me.new":"New password",
  "me.atLeast8":"at least 8 characters",
  "me.repeat":"Repeat the new password",
  "me.language":"Language",
  "shell.back":"Back",
  "shell.needsYou":"What needs you",
  "shell.theme":"Switch between light and dark theme",
  "shell.themeShort":"Light / dark",
  "shell.sections":"Sections",
  "date.months":"January,February,March,April,May,June,July,August,September,October,November,December",
  "date.monthsShort":"Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec",
  "date.days":"Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday",
  "date.daysShort":"Sun,Mon,Tue,Wed,Thu,Fri,Sat",
  "att.pLetter":"P",
  "att.aLetter":"A",
  "abs.sick":"Sick",
  "abs.travel":"Travel",
  "abs.school":"School",
  "abs.family":"Family",
  "abs.other":"Other",
  "me.langNote":"The app opens in this language on every phone you sign in on.",
  "me.changeBtn":"Change password",
  "me.signsOutElsewhere":"Changing it signs you out everywhere else. On this device you stay signed in.",
  "me.thisPhone":"This phone",
  "me.signOutNote":"Signing out ends your session on this device only. You will need your email and password to get back in.",
  "me.signOut":"Sign out",
  "me.enterCurrent":"Enter your current password.",
  "me.tooShort":"The new password must be at least 8 characters.",
  "me.mismatch":"The two new passwords do not match.",
  "me.changing":"Changing…",
  "me.changed":"Password changed",
  "me.changeFail":"Could not change it",
  "me.signOutQ":"Sign out?",
  "me.signOutBody":"You will need your email and password to get back in.",
  "inbox.nOpen":"{n} open",
  "inbox.nMessages":"{n} {message|messages}",
  "inbox.replied":"{name} replied",
  "inbox.kindGood":"Good news",
  "inbox.kindQuestion":"Question",
  "inbox.kindFeedback":"Feedback",
  "inbox.kindOther":"Message",
  "inbox.kindAbsence":"Absence",
  "approvals.emptyTeam":"empty",
  "approvals.failed":"Failed: {error}",
  "phones.you":"you",
  "inbox.saved":"Saved. The family sees it when they open Messages in the portal. Call them if it is urgent.",
  "inbox.replyPlaceholder":"Write a reply. The family sees it in their app.",
  "inbox.landsHere":"What families write from their app lands here.",
  "inbox.closeQ":"Close this message without a reply?",
  "inbox.allAnswered":"Every message has an answer.",
  "inbox.everythingWrote":"Everything families wrote",
  "inbox.waiting":"Waiting for an answer",
  "inbox.writeFirst":"Write the reply first",
  "approvals.loadTeamsFail":"Could not load teams",
  "inbox.closeNoReply":"Close without reply",
  "inbox.discardQ":"Discard your reply?",
  "approvals.withdrawMoveQ":"Withdraw the move?",
  "approvals.withdrawFail":"Could not withdraw",
  "inbox.title":"Parents' messages",
  "inbox.discardAndClose":"Discard and close",
  "approvals.allBranches":"All your branches",
  "inbox.noOpen":"No open messages",
  "inbox.noneYet":"No messages yet",
  "inbox.sendAndClose":"Send and close",
  "inbox.keepWriting":"Keep writing",
  "approvals.anotherTeam":"another team",
  "approvals.noCoachYet":"No coach yet",
  "inbox.noTeamYet":"No team yet",
  "inbox.everything":"Everything",
  "inbox.sendReply":"Send reply",
  "approvals.title":"Approvals",
  "approvals.withdrawn":"Withdrawn",
  "approvals.sendBack":"Send back",
  "inbox.answered":"Answered",
  "approvals.withdraw":"Withdraw",
  "approvals.loading":"Loading…",
  "approvals.approve":"Approve",
  "approvals.noTier":"No tier",
  "inbox.closed":"Closed",
  "approvals.cancel":"Cancel",
  "approvals.yearPick":"Year…",
  "inbox.open":"Open",
  "phones.title":"Phone changes",
  "phones.notYet":"Not yet",
  "home.nudgeLate":"These have been unmarked for days. Without them the attendance record and the reports are wrong.",
  "search.typeTwo":"Type at least two letters. You can search a child, a team, a coach, or the name of a screen.",
  "home.nudgeLateMine":"Your teams have been unmarked for days. The register and the reports are wrong without them.",
  "home.nudgeFunMine":"On your teams. Tap one to mark it. It takes a few seconds.",
  "home.nudgeFirm":"These sessions have no register. Please mark them today.",
  "home.nudgeFun":"Tap a session to mark it. It takes a few seconds.",
  "home.dutiesBlock":"A plan cannot be submitted while these are open.",
  "home.quietPitch":"Nothing in the next seven days. A quiet pitch.",
  "home.nudgeFirmMine":"Your teams have no register for these yet.",
  "bell.approvalsSub":"New players and moves between branches",
  "home.nextLoadFail":"Could not load the next session.",
  "search.placeholder":"Search players, teams, coaches…",
  "bell.parentsMessagesSub":"Families waiting for an answer",
  "bell.staffQuestionsSub":"Coaches waiting for an answer",
  "search.openTeamForCoach":"Open a team to set its coach",
  "home.withBranchHeads":"With the branch head coaches",
  "home.trainingNoPlan":"Training today, no plan yet",
  "home.dutiesLoadFail":"Could not load your duties.",
  "home.plansLoadFail":"Could not load your plans.",
  "bell.phoneChangesSub":"Parent numbers to confirm",
  "bell.plansToReviewSub":"Session plans sent to you",
  "search.opensPlayers":"Opens the Players screen",
  "home.openCoachesOverview":"Open Coaches overview ›",
  "home.plansToReview":"Plans for you to review",
  "home.planSentBack":"Your plan was sent back",
  "home.beforeNextPlan":"Before your next plan",
  "home.noSessionComing":"No session coming up",
  "home.plansLast7":"Plans, last 7 days",
  "home.openOverview":"Open the overview",
  "home.noSessionsToday":"No sessions today",
  "home.showEveryCoach":"Show every coach",
  "search.openScreen":"Open this screen",
  "home.openSession":"Open the session",
  "home.furthestBehind":"Furthest behind",
  "nav.staffQuestions":"Staff questions",
  "home.takeAttendance":"Take attendance",
  "home.getApp":"Get the BFA app",
  "home.openPlan":"Open the plan",
  "home.nextSession":"Next session",
  "branches.all":"All branches",
  "home.reviewThem":"Review them",
  "home.showFewer":"Show fewer",
  "home.notMarked":"Not marked",
  "home.draftOnly":"Draft only",
  "home.noBranch":"No branch",
  "nav.players":"Players",
  "nav.cup":"Cups & Leagues",
  "search.coaches":"Coaches",
  "home.session":"Session",
  "home.dismiss":"Dismiss",
  "nav.search":"Search",
  "home.review":"Review",
  "home.gotIt":"Got it",
  "search.goTo":"Go to",
  "nav.teams":"Teams",
  "nav.newPlan":"New session plan",
  "nav.addExercise":"Add an exercise",
  "nav.inviteFamilies":"Invite families",
  "nav.quickActions":"Quick actions",
  "nav.askForHelp":"Ask for help",
  "nav.coaching":"Coaching",
  "nav.today":"Today",
  "nav.more":"More",
  "home.fromTo":"{from} to {to}",
  "home.ofTrainingsPlanned":"{planned} of {n} {training|trainings} had a plan",
  "home.ofPlanned":"{planned} of {n} planned",
  "home.pushOnCount":"<b>Notifications on:</b> {on} of {staff} coaches and head coaches",
  "home.pushOnCountAll":"<b>Notifications on:</b> {on} of {staff} coaches and head coaches, all branches",
  "home.nPlayers":"{n} {player|players}",
  "search.coachOf":"Coach · {teams}",
  "search.seeAll":"See all {n} matching players",
  "search.noMatch":"Nothing matches “{q}” in what you can see.",
  "home.nSessions":"{n} {session|sessions}",
  "home.nSessionsYours":"{n} {session|sessions} · your teams",
  "bell.labelCount":"{label}: {n}",
  "home.asks":"{who} asks:",
  "home.theReviewer":"The reviewer",
  "home.nextSessionWhen":"Next session · {when}",
  "home.absentLast":"absent last time: {names}",
  "home.appIphone":"iPhone: tap <b>Share</b> <span style=\"font-weight:700\">↑</span>, then <b>Add to Home Screen</b>. The App Store version is on its way.",
  "home.appAndroid":"{link}, or in Chrome: <b>⋮</b> → <b>Add to Home screen</b>.",
  "home.getOnPlay":"Get it on Google Play",
  "home.dayLine":"<b style=\"color:#fff\">{n}</b> {session|sessions} · <b style=\"color:#fff\">{marked}</b> marked · <b style=\"color:#fff\">{left}</b> to mark",
  "home.badgeToMark":"{n} to mark",
  "home.badgeScoresMissing":"{n} {score|scores} missing",
  "home.badgeToFix":"{n} to fix",
  "home.badgeUnassigned":"{n} unassigned",
  "home.nWaiting":"{n} waiting",
  "session.teamVsOpp":"{team} vs {opp}",
  "today.noSessionsSub":"no sessions",
  "today.noMatchFor":"No upcoming match for {branch} yet.",
  "today.noMatch":"No upcoming match yet.",
  "cal.nSessionsIn":"{n} {session|sessions} in {month}",
  "cal.noSessionsIn":"No sessions in {month}",
  "cal.presentAbsent":"{present} present · {absent} absent",
  "session.openFail":"Could not open this session: {reason}",
  "session.connectionProblem":"connection problem",
  "sched.guestGroup":"{branch} team, trains here",
  "session.createGen":"Create & generate sessions",
  "session.existsAdded":"This weekly training already exists · {n} missing sessions added to it",
  "session.createdSessions":"Created · {n} sessions",
  "session.existed":"({n} existed)",
  "session.typeMatch":"Match",
  "session.typeLeague":"League",
  "session.typeFriendly":"Friendly",
  "session.typeTournament":"Tournament",
  "sched.shareFull":"Full pitch",
  "sched.shareHalf":"Half",
  "sched.shareQuarter":"Quarter",
  "sched.shareZone":"Zone (⅛)",
  "session.alsoLater":"Also for the {n} later {session|sessions} of this weekly training",
  "session.nowTeam":"Now {team}",
  "session.nSessionsChanged":"{n} sessions",
  "session.keptFinished":"{n} finished or marked kept",
  "session.dateNotChanged":"{done}. The date and time were not changed: {reason}",
  "session.updatedPlanStayed":"Session updated · the plan stayed on {date}. Re-date it in Training if it belongs to this session.",
  "sched.until":"until {date}",
  "sched.none":"none",
  "sched.add":"Add",
  "session.endBeforeStart":"The end time is before the start time. Set an end after the start, or clear it to keep the session's length.",
  "session.mayStillExist":"The match may still have been created: check the calendar before creating it again.",
  "today.quietPitch":"A quiet pitch. The calendar has the rest of the week.",
  "session.offlineCopy":"No connection. Showing the copy saved on this phone",
  "session.alreadyFinished":"Already finished. Tap Edit again to change",
  "session.untilAfterStart":"Repeat until must be after the start date",
  "session.pastHint":"Some of these days are already past. Mark their attendance once the sessions are created.",
  "session.updatedPlanMoved":"Session updated · the plan moved with it",
  "session.matchCreatedMedia":"Match created · media team asked",
  "cal.nothingThisDay":"Nothing on this day yet.",
  "session.pickUntil":"Pick a repeat-until date",
  "session.noTeams":"No teams in this branch",
  "session.pickDay":"Pick at least one day",
  "session.newWeekly":"New weekly training",
  "session.location":"Location (optional)",
  "session.bookMedia":"Book the Media team",
  "session.nothingToChange":"Nothing to change.",
  "today.openCalendar":"Open the calendar",
  "session.pickStart":"Pick a start time",
  "session.teamOtherBranch":"This team is in another branch. Pick its branch at the top, then add the match.",
  "session.pickStartDate":"Pick a start date",
  "session.oppPlaceholder":"e.g. Sagesse 2013",
  "session.backToCalendar":"Back to calendar",
  "session.pickEnd":"Pick an end time",
  "session.editDateTime":"Edit date & time",
  "session.locPlaceholder":"e.g. FEC Campus",
  "session.updated":"Session updated",
  "session.resultMissing":"Result missing",
  "cal.prevMonth":"Previous month",
  "sched.shareOfPitch":"Share of pitch",
  "session.trainingDays":"Training days",
  "session.matchCreated":"Match created",
  "session.sameDayQ":"This team already has a game that day",
  "session.sameDayOppQ":"This team already has a game that day against the same opponent",
  "session.sameDayBody":"Already on that day:",
  "session.sameDayLine":"{time} · {type}",
  "session.sameDayLineOpp":"{time} · {type} against {opp}",
  "session.saveAnyway":"Save it anyway",
  "session.sameDayNotAdded":"The game was not added.",
  "session.sameDayNotMoved":"The game was not moved.",
  "today.allSessions":"All sessions",
  "session.repeatUntil":"Repeat until",
  "session.createMatch":"Create match",
  "session.edit":"Edit session",
  "session.saveChanges":"Save changes",
  "today.addMatch":"+ Add match",
  "cal.noSessions":"No sessions",
  "session.generating":"Generating…",
  "session.pickDate":"Pick a date",
  "today.nextMatch":"Next match",
  "cal.nextMonth":"Next month",
  "sched.unassigned":"Unassigned",
  "session.cancelled":"Cancelled",
  "session.tryAgain":"Try again",
  "session.newMatch":"New match",
  "cal.title":"Calendar",
  "home.nToDo":"{n} {thing|things} to do",
  "health.players":"{n} {player|players}",
  "past.link":"Past sessions",
  "session.opponent":"Opponent",
  "cal.addMatch":"+ Match",
  "session.saving":"Saving…",
  "session.marked":"Marked",
  "session.start":"Start",
  "sched.pitch":"Pitch",
  "session.venuePlaceholder":"Venue",
  "session.team":"Team",
  "session.from":"From",
  "session.type":"Type",
  "session.date":"Date",
  "session.time":"Time",
  "session.end":"End",
  "sched.sendWhatsApp":"Send on WhatsApp",
  "sched.couldNotLoad":"Could not load",
  "sched.allTeams":"All teams",
  "sched.title":"Schedule",
  "sched.close":"Close",
  "sched.done":"Done",
  "sched.edit":"Edit",
  "player.sendBranchWhy":"They leave their team now and wait in the new branch’s Approvals until its administration places them in a team there. If that branch declines, they come back to this team.",
  "teams.secondSearchHint":"Search any registered player. They keep their main team and pay there; this only adds them to this team’s sessions. Two second teams at most per player.",
  "teams.noneAssignedWhy":"Your head coach sets you as the coach of your teams on the Teams screen. They appear here the moment that is done.",
  "player.deleteBody":"Only possible for players with no attendance and no invoices: mistakes and duplicates. This cannot be undone.",
  "teams.nobodySecondYet":"Nobody from another team trains here yet. A second-team player keeps their main team and fees.",
  "player.secondRemoveBody":"They stop appearing on its sessions. Their main team and fees do not change.",
  "teams.noWeeklyYetSchedule":"No weekly schedule yet. The head coach sets it on the Schedule screen.",
  "players.monthlyOnly":"Monthly package only. Trips and uniforms are invoiced separately.",
  "teams.noneYetWhy":"Your head coach sets the teams up. They will appear here.",
  "player.onlyAdminSecond":"Only administration or a head coach can add a second team",
  "player.moveAsAdmin":"As administration the move is instant, to any branch.",
  "teams.createFirstTeam":"Create the first team to start taking attendance.",
  "teams.secondKeepsMain":"Their main team and fees stay where they are.",
  "player.allTeamsTheirs":"Every team at this branch is already theirs.",
  "teams.noRegisteredByName":"No registered player by that name on a team",
  "player.moveWithinBranches":"Within your branches the move is instant.",
  "player.createOnTeamsFirst":"Create one on the Teams screen first.",
  "players.filterPlaceholder":"Type a name to filter… (showing all)",
  "teams.assignFromDirectory":"Assign players from the directory.",
  "teams.noneAssigned":"No teams assigned to you yet",
  "teams.removedMainUnchanged":"Removed. Main team unchanged",
  "player.consentUnanswered":"Not answered yet: no photos",
  "teams.alreadyTwoSecond":"already has 2 second teams",
  "teams.nothingAhead":"Nothing scheduled ahead.",
  "teams.addSecondPlayerTitle":"Add a second-team player",
  "player.couldNotLoadInvoices":"Could not load invoices.",
  "teams.noPlayersOnTeam":"No players on this team",
  "teams.sendToAnotherBranch":"Send to another branch…",
  "player.noWeeklyYet":"No weekly schedule yet",
  "players.filterAria":"Filter players by name",
  "teams.addToSecondCta":"+ Add to second team",
  "player.addSecondTeamCta":"+ Add a second team",
  "player.consentNo":"No: never in photos",
  "teams.addToSecondTeam":"Add to second team",
  "player.addAsSecondTeam":"Add as second team",
  "player.noOtherTeamHere":"No other team here",
  "player.deletePermanently":"Delete permanently",
  "teams.pitchNotSetYet":"Pitch not set yet",
  "player.addSecondTeamTitle":"Add a second team",
  "player.noTeamsHereYet":"No teams here yet",
  "player.addedToTeam":"Added to the team",
  "teams.type2Letters":"Type 2+ letters.",
  "teams.couldNotRemove":"Could not remove",
  "player.couldNotDelete":"Could not delete",
  "teams.searchByName":"Search by name…",
  "teams.theirMainTeam":"their main team",
  "player.noSecondTeam":"No second team.",
  "teams.assistantCoach":"Assistant coach",
  "teams.couldNotMove":"Could not move",
  "teams.couldNotSend":"Could not send",
  "teams.pitchNotSet":"Pitch not set",
  "teams.searchFailed":"Search failed",
  "teams.couldNotAdd":"Could not add",
  "player.photoConsent":"Photo consent",
  "player.dob":"Date of birth",
  "teams.noneYet":"No teams yet",
  "player.secondTeams":"Second teams",
  "teams.noDaysSet":"No days set",
  "teams.secondTeam":"Second team",
  "teams.thisPlayer":"this player",
  "player.whereItIs":"where it is",
  "teams.assistantTag":"(assistant)",
  "teams.yourTeams":"Your teams",
  "teams.newTeam":"+ New team",
  "teams.squadCard":"Squad card",
  "player.bloodType":"Blood type",
  "teams.thisTeam":"this team",
  "player.thatTeam":"that team",
  "player.playerId":"Player ID",
  "players.feesFor":"Fees for",
  "teams.nextUp":"Next up",
  "player.deleted":"Deleted",
  "teams.trains":"Trains",
  "teams.remove":"Remove",
  "player.branch":"Branch",
  "player.title":"Player",
  "player.father":"Father",
  "player.mother":"Mother",
  "player.school":"School",
  "teams.other":"Other",
  "teams.moved":"Moved",
  "player.phone":"Phone",
  "teams.full":"Full",
  "player.yes":"Yes",
  "teams.pickAgeGroup":"Pick the age group. The name builds itself. Tier is optional.",
  "teams.leftQ":"Mark this player as having left the academy?",
  "teams.assistantDifferent":"The assistant must be a different coach",
  "teams.assistantOptional":"Assistant coach (optional)",
  "teams.leftAcademy":"Left the academy",
  "teams.couldNotSave":"Could not save",
  "teams.markedAsLeft":"Marked as left",
  "teams.noAssistant":"No assistant",
  "teams.markAsLeft":"Mark as left",
  "teams.noCoach":"No coach",
  "teams.saved":"Saved",
  "teams.added":"Added",
  "teams.move":"Move",
  "teams.showingBranch":"Showing {branch}, where your teams are.",
  "teams.nTeams":"{n} {team|teams}",
  "teams.playersCount":"{n} players",
  "teams.coachName":"Coach {name}",
  "teams.assistantName":"Assistant {name}",
  "teams.playersN":"Players · {n}",
  "teams.fromTeam":"From {team}",
  "teams.secondTeamN":"Second team · {n}",
  "teams.secondAdded":"{name} now also trains with {team}. Main team and fees unchanged.",
  "teams.mainTeam":"Main team {team}",
  "teams.since":"since {date}",
  "teams.addSecondQ":"Add {name} as a second-team player?",
  "teams.addSecondBody":"{name} stays on {team} and keeps paying there. This only adds them to {here}’s sessions.",
  "teams.removeSecondQ":"Remove {name} from this team’s sessions?",
  "teams.removeSecondBody":"They stay on {team}. Nothing changes there.",
  "player.teamNumber":"team {id}",
  "player.addedBy":"added by {name}",
  "player.teamFeesStay":"Team: {team}. Fees stay there.",
  "player.removeFromQ":"Remove from {team}?",
  "player.secondPickWhy":"Main team stays {team}. Fees stay there. This only adds the player to a second team’s sessions.",
  "teams.moveName":"Move {name}",
  "player.addName":"Add {name}",
  "teams.sendNameToBranch":"Send {name} to another branch",
  "teams.sentToward":"Sent toward {branch}. Its administration places them in a team there.",
  "player.deleteQ":"Delete {name} permanently?",
  "teams.codeAgeGroup":"{code} + age group",
  "teams.nSelected":"{n} selected",
  "teams.deleteBodyStay":"They stay in the academy and move to Unassigned, where any team can pick them up with <b>+ Add player</b>.",
  "player.leftBodyAnyTime":"They stop being counted and billed. You can bring them back at any time.",
  "teams.adminRestoresOdoo":"Administration can restore the team in Odoo.",
  "teams.deleteTeamQ":"Are you sure you want to delete this team?",
  "teams.pickYearTierBuilds":"Pick year + tier. The name builds itself.",
  "players.tryFewerLetters":"Try fewer letters, or another spelling.",
  "fees.nothingOutstanding":"Nothing outstanding. All settled.",
  "teams.deleteBodyEmpty":"It disappears from every list.",
  "teams.noActivePlayers":"No active players on this team",
  "fees.couldNotLoadInvoice":"Could not load this invoice.",
  "player.notCountedNotBilled":"Not counted and not billed.",
  "teams.eventPlaceholder":"e.g. Neon Cup Athens 2026",
  "player.currentlyAtAcademy":"Currently at the academy.",
  "teams.pickAgeGroupFirst":"Pick the age group first",
  "teams.pickYearTierFirst":"Pick year and tier first",
  "fees.outstandingInvoices":"Outstanding invoices",
  "player.notOnAnyTeamYet":"Not on any team yet",
  "fees.openOriginalPdf":"Open original (PDF)",
  "teams.eventTournament":"Event / tournament",
  "teams.datePlaceholder":"e.g. October 2026",
  "teams.coachOptional":"Coach (optional)",
  "teams.couldNotCreate":"Could not create",
  "players.noneFound":"No players found",
  "teams.dateOptional":"Date (optional)",
  "teams.yesDeleteIt":"Yes, delete it",
  "teams.nameTheEvent":"Name the event",
  "fees.noLineItems":"No line items.",
  "fees.paidInvoices":"Paid invoices",
  "teams.teamDeleted":"Team deleted",
  "player.broughtBack":"Brought back",
  "fees.noInvoices":"No invoices.",
  "teams.noKeepIt":"No, keep it",
  "fees.outstanding":"Outstanding",
  "player.bringBack":"Bring back",
  "teams.creating":"Creating…",
  "teams.makeCard":"Make card",
  "fees.pillCancelled":"cancelled",
  "fees.invoicing":"Invoicing",
  "teams.newTeamTitle":"New team",
  "fees.invoices":"Invoices",
  "fees.savePdf":"Save PDF",
  "fees.noDate":"No date",
  "players.noTeam":"No team",
  "fees.billed":"Billed",
  "fees.total":"Total",
  "fees.paid":"Paid",
  "teams.deleteBodyPlayers":"Its <b>{n} {player|players}</b> stay in the academy and move to Unassigned, where any team can pick them up with <b>+ Add player</b>.",
  "teams.nowHasN":"This team now has {n} {player|players}",
  "teams.namedAutomatically":"Named automatically. Boys: {code} + birth year + tier. Girls: {code} SENIORS or {code} GIRLS + age group.",
  "teams.create":"Create",
  "teams.willBeCreatedAs":"Will be created as {name}.",
  "teams.nameCreated":"{name} created",
  "teams.keepsakeLine":"{team} · {n} players, one keepsake for every family.",
  "player.onTeam":"On {team}",
  "player.aTeam":"a team",
  "player.addToATeam":"Add to a team",
  "player.delete":"Delete",
  "fees.pillDue":"due {amount}",
  "fees.pillPaid":"paid",
  "fees.pillCredit":"credit note",
  "fees.listCount":"{cap} · {n} (tap to open)",
  "fees.listCountOf":"{cap} · {n} of {total} (tap to open)",
  "fees.invoice":"Invoice",
  "fees.invoiceRef":"Invoice {ref}",
  "fees.creditRef":"Credit note {ref}",
  "fees.unapplied":"Unapplied",
  "fees.dueOn":"Due {date}",
  "fees.couldNotFetchPdf":"Could not fetch the invoice PDF",
  "fees.allowPopups":"Your phone blocked the new tab. Allow pop-ups for the app, or use Save PDF.",
  "players.couldNotLoad":"Could not load players. {error}",
  "fees.unpaid":"Unpaid",
  "fees.overdue":"Overdue",
  "fees.partPaid":"Part paid",
  "fees.paymentPending":"Payment pending",
  "fees.cancelled":"Cancelled",
  "fees.noCharge":"No charge",
  "fees.notInvoiced":"Not invoiced",
  "fees.yearlyStatus":"Yearly · {status}",
  "players.noMatch":"No match",
  "players.noPlayers":"No players",
  "players.noneMatchQ":"No players match “{q}”",
  "players.nResults":"{n} {result|results}",
  "players.allPlayersN":"All players · {n}",
  "players.allPlayersShowing":"All players · {n} · showing {shown}, type a name to filter",
  "players.showMore":"Show {n} more · {left} left",
  "att.nothingMarkedYet":"Nothing marked yet. Tap P or A next to each player, then Save for now. Your session plan is saved from the plan form above.",
  "att.waitNotCoach":"Your coach record is linked to another team. Ask administration to check it (Administration › Staff accounts).",
  "att.waitNotLinked":"If that is you, ask administration to link your coach record (Administration › Staff accounts).",
  "att.deleteTrainingBody":"Only for a session created by mistake. If it was planned and is off, use Cancel instead.",
  "att.deleteMatchBody":"Only for a match created by mistake. If it was played or announced, use Cancel instead.",
  "att.deleteTrainingSeriesBody":"Only for sessions created by mistake. If it was planned and is off, use Cancel instead.",
  "att.signedOutMarksSaved":"You were signed out. Your marks are saved on this phone and will sync after you sign in",
  "att.heldFinished":"They are on the sheet now, not saved yet. Tap Edit again, then Finish to keep them.",
  "att.heldOpen":"They are on the sheet now, not saved yet. Tap Save for now or Finish to keep them.",
  "att.coachSaveAsks":"Saving asks whether this is for this session only or for every session from here.",
  "att.noConnectionMarksSaved":"No connection. Your marks are saved on this phone and will sync automatically",
  "att.trialWhy":"A trial or walk-in. Held until administration approves, then added to Odoo.",
  "att.noConnectionPraise":"No connection. Marks saved on this phone; praise once you are back online",
  "att.praiseWhy":"One word, in your name. The family sees it. Pick what you actually saw.",
  "att.tellFamilies":"Please tell the families yourself, with a call or in the branch group.",
  "att.cancelledMeanwhileUncancel":"This session was cancelled meanwhile. Un-cancel it to mark attendance.",
  "att.markedCancelInstead":"Attendance is marked on this session. Cancel it instead of deleting.",
  "att.holidayTraining":"Training is scheduled on this holiday. Cancel it here if it’s off.",
  "att.matchMarked":"Attendance is marked on this match. Cancel it instead of deleting.",
  "att.reasonOptional":"Optional. Saved with the mark when you tap Save for now or Finish.",
  "att.matchHasResult":"This match has a result. Cancel it instead of deleting.",
  "att.alreadyFinishedMarks":"Already finished. Tap Edit again to change the marks",
  "att.closedCancelled":"Attendance is closed. This session is cancelled.",
  "att.parentsNotMessaged":"Families with notifications on get a message on their phone.",
  "att.cancelReasonPlaceholder":"e.g. Rain · Public holiday · Coach unavailable",
  "att.couldNotLoadCoaches":"Could not load coaches. Check your connection",
  "att.finishedTapEdit":"Finished. Tap Edit again to change the marks.",
  "att.stillSavingFinish":"Still saving. Tap Finish again in a moment.",
  "att.saveFirstPraise":"Save the attendance first, then praise",
  "att.cancelledNotMessaged":"Cancelled. Parents were NOT messaged",
  "att.addedToTransit":"Added to transit · pending approval",
  "att.uncancelToMark":"Un-cancel the session to mark it.",
  "att.waitingCoachConfirm":"Waiting for the coach to confirm.",
  "att.deleteTrainingCompletelyQ":"Delete this training completely?",
  "att.assistantFromCoaches":"Assistant coach (from coaches)",
  "att.mediaRequestSent":"Request sent to the media team",
  "att.mediaNotePlaceholder":"Note for the coach (optional)",
  "att.deleteMatchQ":"Delete this match completely?",
  "att.familySaidNotJoining":"The family said: not joining",
  "att.couldNotChangeCoach":"Could not change the coach",
  "att.stillSaving":"Still saving. One moment.",
  "att.mediaNotAvailable":"Media team not available",
  "att.mediaAskAgain":"Ask again",
  "att.stillSavingNoDot":"Still saving. One moment",
  "att.noTrialPlayers":"No trial players added.",
  "att.everySessionFromHere":"Every session from here",
  "att.reasonForCancellation":"Reason for cancellation",
  "att.coachForSession":"Coach for this session",
  "att.mediaRequested":"Media team: requested…",
  "att.addAssistantCoach":"+ Add assistant coach",
  "att.deleteTrainingQ":"Delete this training?",
  "att.couldNotSavePraise":"Could not save praise",
  "att.sessionIsCancelled":"Session is cancelled",
  "att.confirmCancellation":"Confirm cancellation",
  "att.cancellationRemoved":"Cancellation removed",
  "att.hideDetails":"Hide session details",
  "att.confirmAsFinishedQ":"Confirm as finished?",
  "att.attendanceConfirmed":"Attendance confirmed",
  "att.markedNotAvailable":"Marked not available",
  "att.pleaseAddReason":"Please add a reason",
  "att.discardMarks":"Discard these marks",
  "att.familyNotJoining":"Family: not joining",
  "att.reasonPlaceholder":"e.g. back next week",
  "att.discardReason":"Discard the reason?",
  "att.addTrialPlayer":"Add a trial player",
  "att.scorersOptional":"Scorers (optional)",
  "att.scorersPlaceholder":"e.g. Ali 2, Hassan",
  "att.thisSessionOnly":"This session only",
  "att.sessionCancelled":"Session cancelled",
  "att.mediaBooked":"Media team booked",
  "att.onlyThisSession":"Only this session",
  "att.enterBothScores":"Enter both scores",
  "att.aLineOptional":"A line (optional)",
  "att.pendingApproval":"Pending approval",
  "att.phoneOptional":"Phone (optional)",
  "att.changeTheCoach":"Change the coach",
  "att.markAllPresent":"Mark all present",
  "att.absentLastTime":"Absent last time",
  "att.setTheCoach":"+ Set the coach",
  "att.sessionDetails":"Session details",
  "att.marksNotSaved":"Marks not saved",
  "att.marksDiscarded":"Marks discarded",
  "att.addToTransit":"Add to transit",
  "att.cancelSession":"Cancel session",
  "att.deleteSession":"Delete session",
  "att.praiseRemoved":"Praise removed",
  "att.finishAnywayQ":"Finish anyway?",
  "att.theNewCoach":"the new coach",
  "att.notAvailable":"Not available",
  "att.trialPlayers":"Trial players",
  "att.opponentName":"Opponent name",
  "att.matchDeleted":"Match deleted",
  "att.removePraise":"Remove praise",
  "att.confirmAsIs":"Confirm as is",
  "att.finishAnyway":"Finish anyway",
  "att.noMarkQ":"{n} {player|players} {has|have} no mark",
  "att.noMarkBody":"{names}. What happens to them?",
  "att.andNMore":"{n} more",
  "att.markAbsentFinish":"Mark them absent and finish",
  "att.markAbsentFinishOne":"Mark absent and finish",
  "att.goBackMark":"Go back and mark them",
  "att.goBackMarkOne":"Go back and mark",
  "att.finishing":"Finishing…",
  "att.trialPlayer":"Trial player",
  "att.firstName":"First name",
  "att.surname":"Surname",
  "att.enterFirstSurname":"Enter the child's first name and surname.",
  "att.changeCoach":"Change coach",
  "att.offlineCopy":"Offline copy",
  "att.deleteMatch":"Delete match",
  "att.resultSaved":"Result saved",
  "att.addAReason":"Add a reason",
  "att.saveForNow":"Save for now",
  "att.youCoach":"You (coach)",
  "att.cancelling":"Cancelling…",
  "att.changeTime":"Change time",
  "att.saveResult":"Save result",
  "att.uncancel":"Un-cancel",
  "session.tomorrow":"Tomorrow",
  "att.adding":"Adding…",
  "att.bookIt":"Book it",
  "att.keepIt":"Keep it",
  "att.present":"Present",
  "att.goBack":"Go back",
  "att.phonePlaceholder":"+961 …",
  "att.change":"Change",
  "att.pensQ":"Level score: which team won on penalties?",
  "att.pensNeed":"The score is level: pick the team that won on penalties.",
  "att.wonPens":"{team} won on penalties",
  "att.result":"Result",
  "att.absent":"Absent",
  "att.add":"+ Add",
  "att.clear":"Clear",
  "att.none":"None",
  "att.loss":"Loss",
  "att.draw":"Draw",
  "att.win":"Win",
  "session.weekSession":"Week {week}, session {n} · {name}",
  "att.coachNamed":"Coach · {name}",
  "att.coachForTeam":"{who} for {team}.",
  "att.whoDot":"{who}.",
  "att.coachSet":"Coach set: {name}",
  "att.coachCleared":"Coach cleared",
  "att.coachFollow":"{done} · the team and {n} later {session|sessions} follow",
  "att.assistantSet":"Assistant set",
  "att.assistantRemoved":"Assistant removed",
  "att.offlineFrom":"from {when}. Marks you make here are saved on this phone and sent when you are back online.",
  "att.plusSecondTeam":"+{n} second team",
  "att.mediaNoteQuote":"“<span dir=\"auto\">{note}</span>” (Media team)",
  "att.heldMarks":"{n} {mark|marks} you made on this phone {was|were} not saved: {why}",
  "att.lockedMeanwhile":"the sheet was locked meanwhile",
  "att.detailsTraining":"Session details: assistant, trial players, cancel",
  "att.detailsMatch":"Session details: media team, assistant, trial players, cancel",
  "att.detailsMatchDelete":"Session details: media team, assistant, trial players, cancel, delete",
  "att.vsOpp":"vs {opp}",
  "att.scorersLine":"Scorers: {names}",
  "att.thisAndLater":"This and the {n} later {one|ones}",
  "att.sessionDeleted":"Session deleted",
  "att.nSessionsDeleted":"{n} sessions deleted",
  "att.lastTime":"Last time: {praise}",
  "att.changeLink":"change",
  "att.praisedChange":"Praised, change",
  "att.praise":"Praise",
  "att.praiseName":"Praise {name}",
  "att.familyWillSee":"{praise}. {name}'s family will see it",
  "att.confirm":"Confirm",
  "att.heldTitleToday":"Your plan for today waits for this",
  "att.heldTitle":"Your plan waits for this",
  "att.heldText":"“{name}” is saved. Check the names below, then tap Confirm at the bottom. Your plan goes for review by itself.",
  "att.confirmedBy":"confirmed by {name}",
  "att.editAgain":"Edit again",
  "att.finish":"Finish",
  "att.finishOpensShort":"Finish opens at {time}",
  "att.finishOpensAt":"This session has not started yet. Finish opens at {time}, half an hour before it starts.",
  "att.markedByCheck":"Marked by {name}. Check the names, then tap Confirm.",
  "att.nPresent":"{n} present",
  "att.nAbsent":"{n} absent",
  "att.nNotMarked":"{n} not marked",
  "att.confirmUnsavedBody":"{n} {mark|marks} you changed {is|are} not saved. Tap Edit again to keep {it|them}, or confirm the sheet as it was finished.",
  "att.planWentForReview":"Your plan “{name}” went for review",
  "att.plansWentForReview":"{n} of your plans went for review",
  "att.whyAbsent":"Why is {name} absent?",
  "att.booked":"Booked ✓",
  "att.toSync":"{n} to sync",
  "att.held":"{n} held",
  "att.sheetFinished":"This sheet is finished.",
  "att.sheetFinishedBy":"This sheet is finished (by {name}).",
  "att.doneTapEdit":"{done} Tap Edit again to change the marks.",
  "att.finishedMeanwhileBy":"{name} finished this sheet meanwhile.",
  "att.someoneFinishedMeanwhile":"Someone finished this sheet meanwhile.",
  "att.marksStillHere":"Your {n} {mark|marks} {is|are} still here: tap Edit again to apply {it|them}.",
  "att.aSession":"a session",
  "att.someone":"someone",
  "att.finishedItMeanwhile":"{name} finished it meanwhile.",
  "att.yourFinishLanded":"your Finish went through. The sheet is read again.",
  "att.cancelledMeanwhile":"cancelled meanwhile.",
  "att.marksKept":"Your {n} {mark|marks} {is|are} kept on this phone.",
  "att.marksKeptOpen":"Your {n} {mark|marks} {is|are} kept on this phone: open the session.",
  "att.marksKeptOpenEdit":"Your {n} {mark|marks} {is|are} kept on this phone: open the session and tap Edit again.",
  "att.queuedRejected":"A queued save was rejected: {error}",
  "att.synced":"Synced {n} saved {session|sessions}",
  "att.noLongerOnRoster":"{n} {player|players} {is|are} no longer on this roster: {that|those} {mark|marks} {was|were} not saved. Open the session again to see the current team",
  "att.savedCounts":"Saved · {present} present · {absent} absent",
  "att.sheetFinishedMeanwhile":"That sheet was finished meanwhile. Your marks are kept on this phone",
  "att.sheetCancelledMeanwhile":"That sheet was cancelled meanwhile. Your marks are kept on this phone",
  "att.saveFailed":"Save failed: {error}",
  "att.savedCountsCoach":"Saved · {present} present · {absent} absent. The coach still has to confirm",
  "att.reopened":"Reopened for editing",
  "att.finishingNeedsConnection":"Finishing needs a connection. Your marks are saved on this phone and will send.",
  "att.editAgainNeedsConnection":"Edit again needs a connection. Your marks are saved on this phone and will send.",
  "att.theCoach":"the coach",
  "att.theAssistant":"the assistant",
  "att.notMarkedEither":"{who} {is|are} not marked either.",
  "att.youAssistant":"You (assistant)",
  "att.assistantNamed":"Assistant · {name}",
  "att.andJoin":"{a} and {b}",
  "att.notMarkedYet":"{who} {is|are} not marked yet.",
  "staff.sending":"Sending…",
  "home.noteFrom":"Note from {name}",
  "home.noteToday":"Today · tap to close",
  "home.noteDay":"{day} · tap to close",
  "home.thisWeek":"This week",
  "reports.exportFailed":"Export failed",
  "pay.asCoachAsst":"{c} as coach · {a} as assistant",
  "coaches.seeAppAs":"See the app as {name}",
  "login.forgotBody":"Type the email you sign in with. If it has a BFA staff account with a WhatsApp number, we send a link there to choose a new password.",
  "login.pinHelp":"A branch PIN sees only that branch. The admin PIN sees every branch. Signing in with your email uses the access set for you.",
  "login.staySignedHint":"You stay signed in on this phone. On a shared computer, sign out from My account when you finish.",
  "login.forgotHelp":"We send a link to the WhatsApp number on your account. No account yet? Ask your branch admin.",
  "login.linkOnce":"This link works once. Pick a password only you know, at least 8 characters.",
  "login.linkExpired":"Link expired or already used? Ask your branch admin for a new sign-in link.",
  "login.noPasswordYet":"No password yet? Ask an administrator to set one for you.",
  "login.signInFailNet":"Could not sign in. Check your connection and try again.",
  "login.saveFailNet":"Could not save. Check your connection and try again.",
  "login.useEmail":"Use the email your branch admin set up for you.",
  "login.fullEmail":"Type the full email, like name@example.com",
  "login.sendFail":"Could not send it. Try again in a moment.",
  "login.pinAdmin":"Enter the admin PIN to see every branch.",
  "login.accessIssued":"Access is issued by BFA administration.",
  "login.pwTooShort":"Password must be at least 8 characters.",
  "login.pwSaved":"Password saved. Sign in to continue.",
  "login.useOwn":"Use your own email and password.",
  "login.forCoaches":"For coaches and administration.",
  "login.keepSignedIn":"Keep me signed in on this phone",
  "login.emailInstead":"Sign in with your email instead",
  "login.pwMismatch":"The two passwords do not match.",
  "login.enterBoth":"Enter your email and password.",
  "login.pinBranch":"Enter the PIN for this branch.",
  "login.adminAll":"Administration: all branches",
  "login.remember30":"Remember me for 30 days",
  "login.forgot":"Forgot your password?",
  "login.atLeast8":"At least 8 characters",
  "login.choosePassword":"Choose your password",
  "login.parentOf":"Parent of a player?",
  "login.signInEmail":"Sign in with email",
  "login.chooseBranch":"Choose your branch",
  "login.saveAndSignIn":"Save and sign in",
  "login.repeatPassword":"Repeat password",
  "login.everySession":"Every session.",
  "login.privacy":"Privacy policy",
  "login.everyPlayer":"Every player.",
  "login.yourPassword":"Your password",
  "login.showPassword":"Show password",
  "login.hidePassword":"Hide password",
  "login.sendLink":"Send the link",
  "login.signingIn":"Signing in…",
  "login.repeatIt":"Repeat it",
  "login.oneApp":"One app.",
  "login.signIn":"Sign in",
  "login.useIt":"Use it",
  "login.unlock":"Unlock",
  "login.email":"Email",
  "login.back":"Back",
  "core.noServer":"Could not reach the server. Check your connection and try again.",
  "core.tooLong":"That is taking too long. Check your connection and try again.",
  "core.serverProblem":"The server had a problem. Please try again.",
  "att.progNoExample":"No worked example for this session. Run it from the objective.",
  "att.planFromProg":"Plan it from the programme above, or from the library.",
  "att.planFromLib":"Build one from the library in a minute.",
  "att.planWaitHead":"Waiting for the head coach’s review.",
  "att.planNone":"No plan for this session",
  "att.planWaitYou":"Waiting for your review.",
  "att.progChanges":"What changes vs week 1:",
  "att.planSsg":"Small sided game (SSG)",
  "att.planWarmup":"Technical Warm-Up",
  "att.planFunctional":"Functional Drill",
  "att.planModified":"Modified Game",
  "att.planSubmit":"Submit for approval",
  "att.progPlanThis":"Plan this session",
  "att.planOwn":"+ Plan of my own",
  "att.progShape":"Shape on pitch:",
  "att.progWholeWeek":"Whole week",
  "att.planDrawing":"Drawing",
  "att.planSetup":"Setup:",
  "att.planAdd":"+ Plan",
  "att.planReuse":"Reuse",
  "core.discard":"Discard",
  "core.save":"Save",
  "core.undo":"Undo",
  "core.leaveQ":"Leave without saving?",
  "core.leaveMarks":"{n} {mark|marks} on this sheet {is|are} not saved yet.",
  "core.leaveMarksLocked":"The sheet is finished, so {it|they} {stays|stay} on this phone until you open it again and tap Edit again.",
  "core.keepAndGo":"Keep and go",
  "core.saveAndGo":"Save and go",
  "core.stay":"Stay",
  "core.savingMarks":"Saving {n} {mark|marks}…",
  "core.noSignalAt":"No signal. Showing what this phone saved at {time}.",
  "core.noSignalOn":"No signal. Showing what this phone saved on {date}.",
  "pbox.yourPlan":"your plan",
  "pbox.sent":"Sent for approval: {name}",
  "pbox.approved":"Already approved: {name}",
  "pbox.draft":"Draft saved: {name}",
  "pbox.existing":"“{name}” is saved as a draft: this session already has a plan by {by}. Open Plans to submit yours anyway.",
  "pbox.notSent":"“{name}” could not be sent: {error}",
  "pbox.refused":"refused",
  "pbox.sendsItselfNamed":"“{name}” is saved. It goes for review by itself as soon as you {steps}.",
  "pbox.sendsItself":"“{name}” is saved: it goes for review by itself once the team's open step is done.",
  "pbox.duties":"“{name}” is saved as a draft. Do the {step|steps} on Home first, then submit.",
  "core.unsavedKept":"Your {n} unsaved {mark|marks} {is|are} kept on this phone and will sync after you sign in.",
  "core.bookAnywayQ":"Book it anyway?",
  "core.bookAnyway":"Book it anyway",
  "core.replaceWeeklyQ":"Replace the other weekly training?",
  "core.replaceIt":"Replace it",
  "core.noConnectionFirst":"No connection. Open the app once online first.",
  "core.offlineSome":"Offline. Some screens need a connection",
  "login.openPortal":"Open the Family Portal →",
  "login.version":"Version {build}",
  "login.didYouMean":"Did you mean <b>{email}</b>?",
  "login.forgotSent":"If {email} has a staff account with a WhatsApp number, the link is on its way. Open it on this phone. Nothing after a few minutes? Ask your branch admin.",
  "core.signOutQ":"Sign out anyway?",
  "core.signOutPending":"{n} saved {session|sessions} {is|are} still waiting to sync. They stay on this device under your name and go up the next time YOU sign in. Nobody else can send them.",
  "core.signOutAnyway":"Sign out anyway",
  "core.staySignedIn":"Stay signed in",
  "core.branchN":"Branch {id}",
  "core.openFail":"Could not open this. Check your connection and try again.",
  "nav.home":"Home",
  "nav.coachesOverview":"Coaches overview",
  "nav.attendance":"Attendance",
  "nav.feed":"Academy",
  "nav.programme":"Programme",
  "nav.library":"Training",
  "nav.resources":"Resources",
  "nav.assessments":"Assessments",
  "nav.reports":"Reports",
  "nav.fees":"Fees",
  "nav.photoAlbums":"Photo albums",
  "nav.activityLog":"Activity log",
  "nav.playersLeft":"Players who left",
  "nav.attendanceHealth":"Attendance health",
  "nav.overview":"Overview",
  "nav.help":"Help",
  "nav.wholeAcademy":"Whole academy",
  "nav.branchLabel":"Branch: {branch}",
  "nav.oneBranchHere":"This page shows one branch at a time. Pick another above.",
  "core.helperFail":"Could not open the helper",
  "core.viewingAs":"Viewing as {name}",
  "core.exit":"Exit",
  "core.loadScreen":"Could not load this screen",
  "core.loadScreenMod":"Could not load this screen (mod-{name}). Check the connection and try again",
  "tcat.warmup":"Warm-up",
  "tcat.rondo":"Rondo",
  "tcat.possession":"Possession",
  "tcat.passing":"Passing",
  "tcat.finishing":"Finishing",
  "tcat.modified":"Modified game",
  "tcat.ssg":"Small-sided game",
  "tcat.phase":"Phase of play",
  "tcat.physical":"Physical",
  "tcat.allAges":"All ages",
  "core.notForRole":"That page is not available for your role.",
  "core.discardChanges":"Discard your changes?",
  "core.notSavedYet":"What you typed here is not saved yet.",
  "core.keepEditing":"Keep editing",
  "core.areYouSure":"Are you sure?",
  "core.whichOne":"Which one?",
  "core.ok":"OK",
  "core.discardTyped":"Discard what you typed?",
  "core.notSentYet":"It is not sent or saved yet.",
  "date.today":"today",
  "date.yesterday":"yesterday",
  "date.tomorrow":"tomorrow",
  "date.inDays":"in {n} days",
  "session.kickoffSlip":"You picked {time}. Matches start between 06:00 and 21:30. Did you mean {alt}?",
  "teams.allNote":"To create a team or move players, pick the branch at the top.",
  "home.nudgeWhistle":"The whistle went, the sheet stayed empty.",
  "home.nudgeTurnedUp":"The players turned up. The register did not.",
  "home.nudgeNoIdea":"Great session, apparently. The app has no idea.",
  "home.nudgeOneTap":"One tap and we know who was there.",
  "home.nudgeNotTaken":"Attendance still not taken",
  "home.nudgeMissing":"Attendance missing for days",
  "home.justNow":"just now",
  "home.hoursAgo":"{n}h ago",
  "home.daysAgo":"{n} {day|days} ago",
  "bell.unmarked14":"{n} {session|sessions} not marked in 14 days",
  "bell.openHealth":"Open Attendance health",
  "bell.notTaken":"{team}: attendance not taken",
  "bell.branchAsks":"{name}: another branch asks for this player",
  "bell.askedBy":"asked by {name}",
  "home.teamsNeedFixing":"{n} {team|teams} {needs|need} fixing",
  "home.teamsNeedFixingIn":"{n} {team|teams} {needs|need} fixing in {branch}",
  "bell.oldNames":"Old names or no coach set",
  "bell.orphans":"{n} players not on a team",
  "bell.addFromTeam":"Add them from any team’s + Add player",
  "bell.weekHealth":"This week’s health",
  "bell.aCoach":"A coach",
  "bell.planToReview":"{name}: plan to review",
  "bell.noLongerTrains":"{name} no longer trains with {team}",
  "bell.alsoTrains":"{name} also trains with {team}",
  "bell.mainTeamSame":"Main team {team} and fees unchanged",
  "bell.byName":"by {name}",
  "bell.weekPast":"Last 7 days: {n} {session|sessions}, {unmarked} unmarked",
  "bell.weekPastPct":"Last 7 days: {n} {session|sessions}, {unmarked} unmarked, {pct}% present",
  "bell.weekNext":"Next 7: {n} {session|sessions}, {noCoach} without a coach",
  "tour.nextSession":"Your next session",
  "tour.nextSessionBody":"Home opens on your next training: the day, the time, your team, and the programme session for that day.",
  "tour.week":"Your week",
  "tour.weekBody":"Every session of the week at a glance: played, on the programme, still to come.",
  "tour.tapSession":"Tap a session",
  "tour.tapSessionBody":"The programme comes first: the four parts, the coaching points, a drawing when there is one. Then your squad, with a reminder under every name.",
  "tour.skip":"Skip",
  "tour.next":"Next",
  "home.officeTitle":"Today for administration",
  "home.officeUnpaid":"Overdue or due this week",
  "home.officeUnmarked":"Unmarked sessions yesterday",
  "home.officeLow":"Players missing training",
  "home.officeFam":"Families to invite",
  "home.needCall":"{family|families} to call",
  "home.needMark":"to mark",
  "home.needPlans":"waiting for you",
  "home.needDuty":"to do first",
  "home.showAll":"Show all {n}",
  "tfiles.loading":"Files…",
  "tfiles.title":"Files",
  "tfiles.none":"No files yet.",
  "tfiles.add":"+ Add a file",
  "tfiles.noFile":"No file",
  "tfiles.tooLarge":"File too large. Keep it under {mb} MB.",
  "tfiles.readFail":"Could not read that file.",
  "core.photosTitle":"Photos of children",
  "core.photosBody":"Share only photos or videos where every child you can recognise has photo consent: their parent said yes in the Family Portal (it shows on the player's card). A child marked No, or not answered yet, must not appear.",
  "core.photosOk":"Yes, all have consent",
  "tfiles.uploading":"Uploading {name}…",
  "tfiles.added":"Added {name}",
  "tfiles.uploadFail":"Could not upload the file.",
  "tfiles.removeQ":"Remove this file?",
  "tfiles.removeBody":"It disappears for every coach.",
  "tfiles.removed":"Removed",
  "tfiles.removeFail":"Could not remove it",
  "att.planMin":"{n} min",
  "home.noBlocks":"No blocks filled in.",
  "home.sessionPlan":"Session plan",
  "home.whatChange":"What should change?",
  "home.notePlaceholder":"Your note goes back to the coach with the plan",
  "home.writeWhat":"Write what should change. The note goes back to the coach.",
  "home.reviewFail":"Could not save the review",
  "home.planApproved":"Plan approved",
  "home.sentBackNote":"Sent back with your note",
  "home.callLoadFail":"Could not load who to call.",
  "home.callFamily":"Call the family",
  "home.nToCall":"{n} to call",
  "home.allCalled":"all called",
  "home.absentTwice":"Absent twice in a row. A call from you keeps them in the team; tap Done once you have.",
  "home.calledBy":"called by {name} {date}",
  "home.noPhone":"no phone on file",
  "home.notedCalled":"Noted. {name}'s family called",
  "home.todaysProgramme":"Today’s programme",
  "home.withProgramme":"{n} with a programme",
  "home.seeAll":"See all {n}",
  "home.fixHint":"Old names and missing coaches. Each one is a few taps: open the team, pick year + tier, save.",
  "home.fixNow":"Fix now",
  "home.dismissWeek":"Dismiss for this week",
  "core.teamsLoadFail":"Could not load teams. Check your connection",
  "core.loadFail":"Could not load. Check your connection.",
  "core.loadFailShort":"Could not load.",
  "core.loadFailPlain":"This page could not load. Tap Try again. If it keeps happening, tell administration.",
  "core.details":"Details",
  "core.noTeamYet":"<b style=\"color:var(--ink)\">{icon} No team yet, ask your head coach.</b>",
  "core.andNMore":"and {n} more",
  "core.boys":"Boys",
  "core.girls":"Girls",
  "att.planDraft":"Draft",
  "att.planSubmitted":"Submitted",
  "att.planSentBack":"Sent back",
  "att.planApproved":"Approved",
  "att.progHead":"Programme · U{age} {pathway} · Week {week} · Session {n}",
  "att.progHeadOf":"Programme · U{age} {pathway} · Week {week} · Session {n} of {count}",
  "att.progSelection":"Selection",
  "att.progDevelopment":"Development",
  "att.progHide":"Hide the four phases",
  "att.progShow":"Show the four phases",
  "att.progShowExample":"Show the four phases (week 1 example)",
  "att.planDraftBy":"Draft by {name}. Only they or a head coach can edit or submit it.",
  "att.planAnotherCoach":"another coach",
  "library.nMin":"{n} min",
  "prog.titleField":"Title",
  "plans.waitingSignal":"Waiting for signal",
  "plans.waitingOnPhone":"On this phone. It sends by itself when there is signal.",
  "plans.changeThis":"Change this plan",
  "plans.submitted":"Submitted",
  "plans.sentBack":"Sent back",
  "plans.approved":"Approved",
  "att.familyNoteLabel":"Note to the families",
  "att.familyNotePh":"e.g. Shin pads for everyone on Saturday",
  "att.familyNoteHint":"Families of this team see it on their Home for 7 days.",
  "att.familyNoteSaved":"Note saved \u00b7 the families see it for 7 days",
  "att.familyNoteCleared":"Note cleared",
  "cup.homeBy":"Enter your teams by {date} · {n} of {of} entered",
  "cup.homeOpen":"Enter your teams · {n} of {of} entered",
  "cup.open":"Open ›",
  // the Cup by week (Falak 20.10, look B)
  // ID documents (14.10)
  // Private sessions (Falak and the board 14.10, look B; Anthony Mattar's PDF words for the card)
  "nav.privates":"Private sessions",
  "priv.homeCards":"{n} {card|cards} to fill",
  "priv.homeApprove":"{n} to approve",
  "priv.homeMark":"{n} to mark",
  "priv.open":"Open"
};
// The sentence for a key, with its blanks filled: {n} from v.n, {one|many} by whether v.n is 1. An unknown key
// shows itself, never nothing, so a missing word is seen and not silent. In Arabic (9.10) the sentence comes from
// WORDS_AR (words-ar.js, loaded by the shell only for an Arabic phone) and a key it lacks falls back to the English;
// an Arabic pick may have four forms, {one|two|few|many} (1, 2, 3 to 10, else), and # in a pick is the number.
// cards.js's wordsFill is the same fill for the portal; test/arabic.test.js keeps the two alike.
function t(k,v){var a=typeof WORDS_AR!=="undefined"&&WORDS_AR?WORDS_AR[k]:undefined;var s=a!==undefined?a:WORDS[k];if(s===undefined)return k;if(!v)return s;var n=Number(v.n);
  return s.replace(/\{([^{}|]+(?:\|[^{}|]+)+)\}/g,function(m,all){var f=all.split("|");var w=f.length===4?(n===1?f[0]:n===2?f[1]:(n%100>=3&&n%100<=10)?f[2]:f[3]):f.length===2?(n===1?f[0]:f[1]):m;return w.replace(/#/g,String(v.n));}).replace(/\{(\w+)\}/g,function(m,x){return v[x]===undefined?m:String(v[x]);});}
